//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex'
import PlansMixin from '~/mixins/plans'

export default {
  mixins: [PlansMixin],
  props: {
    /**
     * Whether to show the pay now button
     */
    showPayNowButton: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    ...mapState('product', ['baseCompleteTests', 'improvementProgramPrice', 'foodTestPrice']),
    ...mapGetters({
      getNutritionalPlanPrice: 'product/getNutritionalPlanPriceRaw',
      isBaseCompleteImprovementPlan: 'product/isBaseCompleteImprovementPlan',
      isBaseImprovementPlan: 'product/isBaseImprovementPlan',
      isQuizPlanResults: 'product/isQuizPlanResults',
      getPlanPriceRaw: 'product/getFoodSensitivityTestPriceRaw',
      getImprovementProgramPrice: 'product/getImprovementProgramPrice'
    }),
    specifications () {
      return this.$t('nutritionalPlan.header.specifications')
    }
  },
  methods: {
    navigateToStripePayment () {
      window.location.href = 'https://buy.stripe.com/fZebKA041fQL0Ba7sT'
    }
  }
}
